'use client'

import { IconMoon, IconSun, IconDeviceDesktop } from '@tabler/icons-react'
import { Button } from '@/components/ui/button'
import { useTheme } from '@/components/theme-provider'

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme()

  const cycleTheme = () => {
    // Cycle through: system → light → dark → system
    if (theme === 'system') {
      setTheme('light')
    } else if (theme === 'light') {
      setTheme('dark')
    } else {
      setTheme('system')
    }
  }

  const icon =
    theme === 'light' ? (
      <IconSun className="h-[1.2rem] w-[1.2rem]" />
    ) : theme === 'dark' ? (
      <IconMoon className="h-[1.2rem] w-[1.2rem]" />
    ) : (
      <IconDeviceDesktop className="h-[1.2rem] w-[1.2rem]" />
    )

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycleTheme}
      aria-label="Toggle theme"
    >
      {icon}
    </Button>
  )
}
